import clubRequest from "../axios";

const getAllGalleryImages = async () =>
  (await clubRequest.merchantGalleryList()).data;

const addGalleryImage = async (file: File) =>
  (
    await clubRequest.merchantGalleryCreate({
      Caption: "",
      file: file,
    })
  ).data;

const deleteGalleryImage = async (id: number) =>
  (await clubRequest.merchantGalleryDelete({ id })).data;

export { addGalleryImage, deleteGalleryImage, getAllGalleryImages };
